import { Box, Typography, useTheme } from "@mui/material";
import { BellAlertOutlined } from "Icons/Icons";
import { FONT_WEIGHTS } from "Theme/Typography/Constants";
import { LinkButton, RouterLinkBehavior } from "Common/Components";

export const NotificationsEmptyState = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <BellAlertOutlined
        sx={{
          width: 80,
          height: 80,
          color: theme.palette.primary.main,
          mb: theme.spacing(2),
        }}
      />

      <Typography
        variant="body1"
        sx={{
          mb: theme.spacing(0.5),
          fontWeight: FONT_WEIGHTS.SEMI_BOLD,
        }}
      >
        No New Notifications
      </Typography>

      <LinkButton
        component={RouterLinkBehavior}
        to={`${import.meta.env.VITE_NOTIFICATION_APP_URL}/notifications`}
        target="_blank"
        rel="noopener noreferrer"
      >
        View all notifications &rarr;
      </LinkButton>
    </Box>
  );
};
